import { render, staticRenderFns } from "./ModalCreateAttribute.vue?vue&type=template&id=3ae5478d&"
import script from "./ModalCreateAttribute.vue?vue&type=script&lang=js&"
export * from "./ModalCreateAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports